// extracted by mini-css-extract-plugin
export default {"container":"Popup_container__sHKKU","textArea":"Popup_textArea__BD6lD"};